import CheckoutDetails from "./checkoutDetails.container";

export default CheckoutDetails;
